/* eslint-disable import/prefer-default-export */
import { FieldFunctionOptions, FieldPolicy, Reference } from '@apollo/client'

import { ReleaseNotesFilterInput } from '~generated/types'
import { getNewIncomingData } from '~lib/apollo/entities/utils'

type PaginatedReleaseNotesCacheObj = {
  docs?: Reference[]
  limit?: number
  page?: number
  nextPage?: number
  prevPage?: number
  hasNextPage?: boolean
  hasPrevPage?: boolean
  totalDocs?: number
  totalPages?: number
  pagingCounter?: number
}

type Existing = PaginatedReleaseNotesCacheObj
type Incoming = PaginatedReleaseNotesCacheObj

export function createPaginatedReleaseNotesQueryCache(): FieldPolicy<Existing, Incoming> {
  return {
    keyArgs: () => {
      const filterKeysDict: KeysEnum<ReleaseNotesFilterInput> = {
        tagIds: true,
        launchIds: true,
        ownerIds: true,
        query: true,
        startDueDate: true,
        endDueDate: true,
        dueDateExists: true,
        live: true,
        internal: true,
      }

      return ['filter', Object.keys(filterKeysDict)]
    },

    merge: (existing: Existing, incoming: Incoming, { readField, canRead }: FieldFunctionOptions) => {
      const { docs: existingDocs = [] } = existing || {}
      const { docs: incomingDocs = [] } = incoming

      const newIncomingDocs = getNewIncomingData({
        incomingData: incomingDocs,
        existingData: existingDocs,
        readField,
      })

      return {
        ...existing,
        ...incoming,
        docs: [...existingDocs, ...newIncomingDocs].filter(canRead),
      }
    },

    read: (existing: Existing, { canRead }: FieldFunctionOptions) => {
      if (!existing) return undefined

      const existingDocs = [...(existing?.docs || [])].filter(canRead)

      return {
        ...existing,
        docs: existingDocs,
      }
    },
  }
}
